import { DateTime } from 'luxon';
import { Employee } from '../models/employee';
import { Unit } from '../models/unit';
import { PlcGradeCode } from "../models/plc-grade-code";
import { PieceRateAttendanceGoalType } from "../models/piece-rate-attendance-goal-type";

export class PieceRateAdjustment {
    id: number;
    siteId: string;
    date: DateTime;
    shiftId: number;
    weekIsClosed: boolean;
    weekIsLocked: boolean;
    builderEntries: PieceRateAdjustmentEntryBuilder[];
    activityConfigs: PieceRateAdjustmentActivityConfig[];
}

export class PieceRateAdjustmentActivityConfig {
    pieceRateActivity: number;
    jobCode?: string;
    showSecondaryCount?: boolean;
    showQuality?: boolean;
    showMetAttendanceGoal?: boolean;
    attendanceGoalType?: PieceRateAttendanceGoalType;
    showComponentsFields?: boolean;
    showTab?: boolean;
    showNonProductiveHours?: boolean;
    showGroupTotals?: boolean;
    groupQualityTarget?: number;
    groupPenaltyMultiplier?: number;
    displayUnit: Unit;
}

export class PieceRateAdjustmentEntryBuilder {
    id?: number;
    builderId?: number;
    pieceRateActivityId?: number;
    builder?: Employee;
    productId?: number;
    count?: number;
    secondaryCount?: number;
    auditedCount?: number;
    failedCount?: number;
    metAttendanceGoal?: boolean;
    qualityTarget?: number;
    penaltyMultiplier?: number;
    nonProductiveHours?: string;
    tableNumber?: number;
    sortOrder?: number;
    plcCodeId?: number;
    qrCode?: number;
}

export interface PlcEntry {
    qrCode?: number;
    plcCount?: number;
    gradeCode: PlcGradeCode;
}
